export default {
  // Index
  productDemo: {
    english: "Product Demo",
    spanish: "Demostración del producto",
  },
  // haveAQuestion listed in chat-now
};
